import * as React from 'react';
import { useCountdown } from 'shared/hooks/countdown';

interface Props {
  to: string;
  onExceed?: () => void;
}

export const Countdown: React.SFC<Props> = ({ to, onExceed }) => {
  const [days, ...time] = useCountdown(to, onExceed);
  time[0] += days * 24;

  return <>{time.map((value) => `${value}`.padStart(2, '0')).join(' : ')}</>;
};
